const menuList = (pathname) => [
  {
    key    : 'home',
    title  : 'menu.home',
    active : pathname === '/',
    to     : '/',
    icon   : 'home',
  },
  {
    key    : 'show',
    title  : 'menu.show',
    active : pathname === '/music-show',
    to     : '/music-show',
    icon   : 'microphone',
  },
  {
    key    : 'gbacademy',
    title  : 'menu.gbacademy',
    active : pathname === '/gbacademy',
    to     : '/gbacademy',
    icon   : 'microphone',
    img    : 'GB-academy-icon.png',
  },
  {
    key    : 'blog',
    title  : 'menu.blog',
    active : pathname === '/blog',
    to     : 'https://blog.gaelleboudier.com',
    icon   : 'newspaper',
  },
  // {
  //   key    : 'lesson',
  //   title  : 'menu.lesson',
  //   active : pathname === '/lesson',
  //   to     : '/lesson',
  //   icon   : 'music',
  // },
  // {
  //   key    : 'choir',
  //   title  : 'menu.choir',
  //   active : pathname === '/music-choir',
  //   to     : '/music-choir',
  //   icon   : 'users',
  // },
  // {
  //   key    : 'musicawareness',
  //   title  : 'menu.musicawareness',
  //   active : pathname === '/music-awareness',
  //   to     : '/music-awareness',
  //   icon   : 'music',
  // },
  // {
  //   key    : 'price',
  //   title  : 'menu.price',
  //   active : pathname === '/price',
  //   to     : '/price',
  //   icon   : 'dollar',
  // },
  // {
  //   key    : 'musictherapy',
  //   title  : 'menu.musictherapy',
  //   active : pathname === '/music-therapy',
  //   to     : '/music-therapy',
  //   icon   : 'headphones',
  // },
  // {
  //   key    : 'shop',
  //   title  : 'menu.shop',
  //   active : pathname === '/shop',
  //   to     : '/shop',
  //   icon   : 'shopping bag',
  // },
  {
    key    : 'about',
    title  : 'menu.about',
    active : pathname === '/about',
    to     : '/about',
    icon   : 'id card',
  },
  // {
  //   key    : 'review',
  //   title  : 'menu.review',
  //   active : pathname === '/review',
  //   to     : '/review',
  //   icon   : 'user circle',
  // },
  {
    key    : 'contact',
    title  : 'menu.contact',
    active : pathname === '/contact',
    to     : '/contact',
    icon   : 'mail',
  },
  // {
  //   key    : 'calendar',
  //   title  : 'menu.calendar',
  //   active : pathname === '/calendar',
  //   to     : '/calendar',
  //   icon   : 'calendar',
  // },
];

export default menuList;



// WEBPACK FOOTER //
// ./src/global/menuList.js